module.exports = __webpack_public_path__ + "img/Infinity-1s-200px.6be83a16.gif";